import { SkyscannerContentdistributionV1MediaDistributionService } from '@skyscanner-internal/cp-distribution-api-web-http-client';
import { CONTENT_PLATFORM_MEDIA_DISTRIBUTION } from '@web-platform/shared-universal-types/src/network/requestTypes';

import { grpcFetchClientWrapper } from '../../internals/clients/grpc/grpc';

export const contentPlatformDistributionSearchRequest = grpcFetchClientWrapper(
  SkyscannerContentdistributionV1MediaDistributionService.MediaDistributionService.Search,
  {
    clientName: CONTENT_PLATFORM_MEDIA_DISTRIBUTION,
    pathPrefix: '/g/content/distribution',
  },
);
